import { render, staticRenderFns } from "./OrderReturnUpdatePage.vue?vue&type=template&id=25e306df"
import script from "./OrderReturnUpdatePage.vue?vue&type=script&lang=js"
export * from "./OrderReturnUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports